import type { Action, Reducer, State } from '../use_candidate_profile';

export const activityFeedReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'setActivityItems': {
      const { activity_feed, has_more } = action.payload;

      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          activityItems: activity_feed,
          hasMore: has_more,
        },
      };
    }
    case 'addActivityItems': {
      const { activity_feed, has_more } = action.payload;

      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          activityItems: [
            ...(state.activityFeed.activityItems ?? []),
            ...activity_feed,
          ],
          hasMore: has_more,
        },
      };
    }
    case 'removeActivityItem': {
      const { itemId } = action.payload;

      if (!state.activityFeed.activityItems) {
        return state;
      }

      const activityItems = state.activityFeed.activityItems.filter(
        (item) => item.id !== itemId
      );

      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          activityItems,
        },
      };
    }
    case 'setActivityFilters': {
      return {
        ...state,
        activityFeed: {
          ...state.activityFeed,
          filters: {
            ...state.activityFeed.filters,
            ...action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
};
